import ApiService from '../../services/ApiService';

export const loadData = url => {
    return new Promise((resolve, reject) => {
        EventBus.$emit('show-loading', true);

        ApiService.get(url)
            .then(response => {
                resolve(response.data);
                EventBus.$emit('show-loading', false);
            })
            .catch(errors => {
                EventBus.$emit('show-loading', false);
                reject(errors.response ? errors.response.data : new Error('Response undefined'));
            });
    });
};
